import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgProstitutie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M12 12a8 8 0 0 1 8.53-8A8.18 8.18 0 0 1 28 12.27V17a8 8 0 1 1-16 0z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M20 5.46s.39 9-6 10.25l-1.19-5.11L15.94 6z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M21.69 5.18a9.4 9.4 0 0 1 0 2.54c-.108.798-.31 1.58-.6 2.33A9.6 9.6 0 0 1 20 12.13c-.438.63-.945 1.21-1.51 1.73.426-.627.785-1.297 1.07-2 .278-.673.47-1.379.57-2.1a9 9 0 0 0 .07-2.12 7.5 7.5 0 0 0-.42-2z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M27.67 25.27h-5.16v-1h5.16zM27.67 22.81h-5.16v-1h5.16z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.255 17.5a6 6 0 0 1 2.987.753l-.484.874a5 5 0 1 0 0 8.746l.484.874A6 6 0 1 1 29.255 17.5"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgProstitutie);

export default ForwardRef;
